import { requestDeleteFiles } from "src/requests/files/requestCreators";
import { FileMetadata } from "src/requests/files/types";
import flowioast from "src/utils/flowioast";
import { FileConfigParams } from "../types";
import { getErrorMsgForDeleteFailedFiles } from "../utils";

type UseDeleteFiles = (
  params: FileConfigParams
) => (removedFiles: FileMetadata[]) => Promise<void>;

const useDeleteFiles: UseDeleteFiles = (params) => {
  const { recordId, templateItemId, templateId } = params;

  const handleFailedDeleteFiles = (
    failedIds: string[],
    removedFiles: FileMetadata[]
  ): void => {
    if (!failedIds.length) return;

    const failedFileString = getErrorMsgForDeleteFailedFiles(
      failedIds,
      removedFiles
    );

    flowioast.error.noStack.fromIntlId(
      "segments.file_input.files_delete.error",
      undefined,
      {
        fileNames: failedFileString,
      }
    );
  };

  const deleteFiles = async (removedFiles: FileMetadata[]): Promise<void> => {
    const fileIdsToDelete = removedFiles.map((file) => file.id).map(String);
    const {
      data: { failed },
    } = await requestDeleteFiles(fileIdsToDelete, {
      templateId,
      recordId,
      templateItemId,
    });

    handleFailedDeleteFiles(failed, removedFiles);
  };

  return deleteFiles;
};

export default useDeleteFiles;
